module.exports = __webpack_public_path__ + "static/Product-Online-Fullframe-6.8ac170f3.jpg";